import Furniture from './Furniture';

export default class Lantern extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.isLit = false;

    if (data.state === 'on') {
      this.lightUp();
    }
  }

  createAsset() {
    this.lantern = this.game.make.image(0, 0, this.data.key, 'lantern');
    this.lantern.anchor.set(0.5, 1);
    this.branch = this.game.make.image(15, -212, this.data.key, 'branch');
    this.branch.anchor.set(0.5);
    this.candleOff = this.game.make.image(12, -44, this.data.key, 'candle_off');
    this.candleOff.anchor.set(0.5, 1);
    this.candleOn = this.game.make.image(11.5, -44, this.data.key, 'candle_on');
    this.candleOn.anchor.set(0.5, 1);
    this.glow = this.game.make.image(12, -100, this.data.key, 'glow');
    this.glow.anchor.set(0.5);

    this.scale.x = this.data.scale.x;
    this.scale.y = this.data.scale.y;

    this.addChild(this.branch);
    this.addChild(this.lantern);
    this.addChild(this.candleOff);
    this.addChild(this.candleOn);
    this.addChild(this.glow);

    this.candleOn.visible = false;
    this.glow.alpha = 0;
  }

  //
  setNight() {
    if (this.isLit) {
      this.game.add.tween(this.glow).to({ alpha: 1 }, 500, null, true);
    }
  }

  setDay() {
    this.game.add.tween(this.glow).to({ alpha: this.isLit ? 0.25 : 0 }, 500, null, true);
  }

  setLight(power) {
    this.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.branch.tint = this.tintColor;
    this.lantern.tint = this.tintColor;
    this.candleOff.tint = this.tintColor;
  }

  handleInputDown() {
    if (!this.isLit) this.lightUp();
    else this.turnOff();

    this.game.sounds.playSFX('item_lantern', { spriteID: 'sfx' });

    //
    this.onChange.dispatch();
  }

  lightUp() {
    if (!this.isLit) {
      this.isLit = true;
      this.candleOff.visible = false;
      this.candleOn.visible = true;

      if (this.location.isDay()) {
        this.glow.alpha = 0.25;
      } else {
        this.glow.alpha = 1;
      }
    }
  }

  turnOff() {
    if (this.isLit) {
      this.isLit = false;
      this.candleOff.visible = true;
      this.candleOn.visible = false;

      this.glow.alpha = 0;
    }
  }

  //
  serialize() {
    const data = super.serialize();
    data.state = this.isLit ? 'on' : 'off';
    return data;
  }
}
